import {PlayerValuationAPI} from "@/api/player_valuation";

/**
 * Fetch average rating (finalAverage) for a player in a given season.
 * Returns a number or null if no valid valuations are found.
 */
export const fetchPlayerRating = async (playerId, seasonId) => {
	if (!playerId || !seasonId) {
		return null;
	}

	try {
		const valuations = await PlayerValuationAPI.playerList(playerId, {seasonId});

		if (!valuations || !valuations.length) {
			return null;
		}

		let sum = 0;
		let count = 0;

		valuations.forEach((valuation) => {
			if (
				valuation.finalAverage !== null &&
				valuation.finalAverage !== undefined
			) {
				const value =
					typeof valuation.finalAverage === "number"
						? valuation.finalAverage
						: parseFloat(valuation.finalAverage);

				if (!Number.isNaN(value)) {
					sum += value;
					count += 1;
				}
			}
		});

		if (!count) {
			return null;
		}

		return sum / count;
	} catch (error) {
		// Silently fail – caller can decide how to handle missing rating
		// console.warn("Error fetching player rating", playerId, error);
		return null;
	}
};


